// extracted by mini-css-extract-plugin
export var button = "_lf-0";
export var donut = "_lf-1";
export var donutFill = "_lf-3";
export var donutTrack = "_lf-2";